/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

// project imports
import store from 'features/store';

// style imports
import './Sidebar.scss';
import { useSelector } from 'react-redux';
import { Accordion } from 'shared/hoc/accordion/Accordion';

/**
 * defines sidebar once login is made
 * 
 * @param props
 * 
 * @returns html code to render sidebar code
 * 
**/

export class Sidebar extends Component {

    onLogoutUser = () => {
        store.dispatch({ type: 'TOGGLE_LOGOUT_MODAL', payload: true });
    };

    isDisabledLink = (flag) => {
        const list = ['Collectibles', 'Craft & Hobby', 'Electronics', 'Jewlery', 'Motor Vechicles']
        return list.includes(flag);
    }

    render() {
        const { user, sidebarMenuList } = this.props;
        const filteredMenuList = sidebarMenuList.menuList.filter(menu => {
            if (user?.membershipCompleted === 1 && menu.name === 'Become a Premier Member') {
                return false;
            }
            if (user?.membershipCompleted === 0 && menu.name === 'My Premier Benefits ') {
                return false;
            }
            return true;
        });

        return (
            <div className="d-flex flex-column sidebar-box">
                {/* <div className="d-flex d-lg-none flex-row align-items-center justify-content-between sidebar-tools">
                    <div className="d-flex flex-row">
                        <div className="d-flex flex-row profile-border-outer">
                            <div className="profile-border-inner">
                                <img src={this.props['user']['profileImage'] ? this.props['user']['profileImage'] : (process.env.PUBLIC_URL + '/static/icons/profile/default_1.svg')} alt="profile" height="28" width="26" className="profile" />
                            </div>
                        </div>
                        <div className="d-flex flex-row align-items-center">
                            <b>{`${this.props['user']['lastName']},${this.props['user']['firstName']}`}</b>
                        </div>
                    </div>
                </div> */}
                <ul className="d-flex flex-column menu-list">
                    {
                        filteredMenuList.map((menu, i) => (
                            menu?.sub_menu?.length > 0 ? <li key={`links_${i}`}>
                                    <div className={`d-flex flex-column mt5 ${this.props.location.pathname.includes(menu?.include) ? 'active-item' : ''}`}>
                                        <Link to={`${menu.path}`}>
                                            <div className={`d-flex flex-row menu-item ${this.props.location.pathname === menu?.include ? 'menu-item-active' : ''} ${this.isDisabledLink(menu.name) ? 'disabled' : ''}`}>
                                                <div className="d-flex flex-row align-items-center justify-content-between menu-item-name">
                                                    {
                                                        this.props.sidebarMenuList.withSpan ?
                                                            <div className="d-flex"><span></span>&ensp;<div>{menu.name}&#40;{i + 12}&#41;</div></div>
                                                            :
                                                            <div className="main-link d-flex align-items-center justify-content-between">
                                                                {menu.name} <i className={`fas ${this.props.location.pathname.includes(menu?.include) ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
                                                            </div>
                                                    }
                                                </div>
                                            </div>
                                        </Link>
                                        <div className="d-flex flex-column align-items-center justify-content-center sub-menu">
                                            {
                                                menu.sub_menu.map((sub_menu, j) => {
                                                    return (
                                                        <Link to={`${sub_menu.path}`} className={`sub-menu-item ${this.props.location.pathname.includes(sub_menu?.include) || (this.props.location.pathname === '/my-account/premier/premier-membership' && sub_menu?.include == "/member-benefits") ? 'sub-menu-active' : ''}`} key={`sub_menu_${j}`}>
                                                            <div className={`d-flex flex-row`} style={{ position: 'relative' }}>
                                                                <div className="d-flex align-items-around justify-content-end sub-menu-item-name">
                                                                    {
                                                                        this.props.sidebarMenuList.withSpan ?
                                                                            <div className="d-flex"><span></span>&ensp;<div>{sub_menu.name}&#40;{j + 5}&#41;</div></div>
                                                                            :
                                                                            <div className="sub-link d-flex align-items-center">
                                                                                <i className="fas fa-angle-right"></i> {sub_menu.name}
                                                                            </div>
                                                                    }
                                                                </div>
                                                                {
                                                                    (sub_menu.name === 'Payment Methods' && !this.props.user.paymentcompleted) ||
                                                                    (sub_menu.name === 'Personal Interests' && !this.props.user.interestCompleted) ||
                                                                    (sub_menu.name === 'Personal Info' && !this.props.user.profilecompleted) ? 
                                                                        <div className='bg-danger text-white rounded-circle text-center' style={{ position: 'absolute', right: '35px', bottom: '-2px', paddingRight: '2px', width: '25px', height: '25px', fontWeight: 900 }}>!</div> 
                                                                        : 
                                                                        null
                                                                }
                                                            </div>
                                                        </Link>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                </li> : <li key={`links_${i}`}>
                                    <div className={`d-flex flex-column ${this.props.location.pathname === menu?.include ? 'menu-item-active' : ''} ${this.isDisabledLink(menu.name) ? 'disabled' : ''}`}>
                                        <Link to={`${menu.path}`}>
                                            <div className="d-flex flex-row menu-item">
                                                <div className="d-flex flex-column align-items-start justify-content-center menu-item-name">
                                                    {
                                                        this.props.sidebarMenuList.withSpan ?
                                                            <div className="d-flex"><span></span>&ensp;<div>{menu.name}&#40;{i + 12}&#41;</div></div>
                                                            :
                                                            <div className="main-link">{menu.name}</div>
                                                    }
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                </li>
                        ))
                    }
                    {/* <li className="d-lg-none">
                        <div className="d-flex flex-row menu-item" onClick={this.onLogoutUser}>
                            <img src={`${process.env.PUBLIC_URL}/static/icons/header/logout.svg`} alt="logout" height="25px" width="25px" style={{ margin: '4px 8px' }} />
                            <div className="d-flex flex-column align-items-start justify-content-center menu-item-name">
                                <span>Sign Out</span>
                            </div>
                        </div>
                    </li> */}
                </ul>
            </div>
        );
    }
}

const SIDEBAR_MENUS = [
    { label: 'Become a Premier Member', type: "link", include: '/my-account/join-premier-member', redirectTo: '/my-account/join-premier-member' },
    {
        label: 'My Premier Benefits ',
        type: "link",
        include: '/my-account/premier',
        redirectTo: '/my-account/premier/member-benefits',
        sub_menu: [
            { label: 'Delivery Guarantee', type: "link", include: '/delivery-guarantee', redirectTo: '/my-account/premier/delivery-guarantee' },
            { label: `Total Access`, type: "link", include: '/total-access', redirectTo: '/my-account/premier/total-access' },
            { label: 'WorthPoint', type: "link", include: '/worthpoint', redirectTo: '/my-account/premier/worthpoint' },
            { label: 'Auction Sneak Peek', type: "link", include: '/auction-sneak-peak', redirectTo: '/my-account/premier/auction-sneak-peak' },
            { label: 'Premier Advisor', type: "link", include: '/advisor', redirectTo: '/my-account/premier/advisor' },
            { label: 'Premier Account', type: "link", include: '/premier-account', redirectTo: '/my-account/premier/premier-account' },             
            { label: `Alzheimer's Foundation`, type: "link", include: '/alzheimers-foundation', redirectTo: '/my-account/premier/alzheimers-foundation'}
        ]
    },
    {
        label: 'My Info',
        type: "link",
        include: '/my-account/my-info',
        redirectTo: '/my-account/my-info/personal-info',
        sub_menu: [
            { label: 'Personal Info', type: "link", include: '/personal-info', redirectTo: '/my-account/my-info/personal-info' },
            { label: 'Personal Interests', type: "link", include: '/personal-interests', redirectTo: '/my-account/my-info/personal-interests' },
            { label: 'Payment Methods', type: "link", include: '/payment-methods', redirectTo: '/my-account/my-info/payment-methods' },
            { label: 'Change Password', type: "link", include: '/change-password', redirectTo: '/my-account/my-info/change-password' },
            { label: 'Tax Exemptions', type: "link", include: '/tax-exemptions', redirectTo: '/my-account/my-info/tax-exemptions' },
            { label: 'Delete Your CTBids Account', type: "link", include: '/delete-account', redirectTo: '/my-account/my-info/delete-account' }
        ]
    },
    {
        label: 'Invoices/Receipts',
        type: "link",
        include: '/my-account/invoice',
        redirectTo: '/my-account/invoice',
        sub_menu: [
            { label: 'Shipped Items', type: "link", include: '/shipped-items', redirectTo: '/my-account/invoice/shipped-items' }
        ]
    },
    { label: 'Make It Returnable Status', type: "link", include: '/my-account/mir', redirectTo: '/my-account/mir' },
    { label: 'Delivery Guarantee Status', type: "link", include: '/my-account/gd', redirectTo: '/my-account/gd' },
    { label: 'Notification', type: "link", include: '/my-account/notification-preferences', redirectTo: '/my-account/notification-preferences' }
];

export const SideBarNew = (props) => {

    return (
        <div className='sidebar-box'>
            <Accordion props={props} menuData={SIDEBAR_MENUS} />
        </div>
    );
};